<div fxFlex fxLayoutAlign="center center" style="margin-top: 20px;">
    <div fxLayout="column" fxFlex="90">
        <div [fxHide]="studentType != 1">
            <app-disclaimercontent></app-disclaimercontent>
        </div>
        <div [fxHide]="studentType == 1">
            <app-disclaimercontentoversees></app-disclaimercontentoversees>
        </div>
    </div>
</div>